import serverCall from "../../serverCall";

const login = (email, password) => {
  try {
    const response = serverCall.post(
      `/auth/admin/login?email=${email}&password=${password}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

const AuthService = {
  login,
};

export default AuthService;
